import React, { useContext } from "react";
import { LayoutContext } from "../shop/index";
import { LayoutDashboard, Layers, ClipboardList, Globe, SlidersHorizontal, Sun, Moon } from "lucide-react";

const Sidebar = () => {
    const {
        isDarkMode,
        toggleDarkMode,
        isSidebarOpen,
        colors,
        data,
        dispatch
    } = useContext(LayoutContext);

    const activeTab = data.activeTab || "overview";
    const sidebarWidth = isSidebarOpen ? "260px" : "80px";

    const menuItems = [
        { id: "overview", Icon: LayoutDashboard, label: "Overview" },
        { id: "inventory", Icon: Layers, label: "Leather Inventory" },
        { id: "orders", Icon: ClipboardList, label: "Customer Designs" },
        { id: "locales", Icon: Globe, label: "Locales" },
        { id: "options", Icon: SlidersHorizontal, label: "Strap Options" },
    ];

    return (
        <div className="d-flex flex-column position-relative"
            style={{
                width: sidebarWidth,
                minWidth: sidebarWidth,
                backgroundColor: colors.bgSidebar,
                zIndex: 1000,
                borderRight: `1px solid ${colors.borderColor}`,
                transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
                height: '100vh'
            }}>

            {/* LOGO & TOGGLE DARK MODE */}
            <div className="p-4 d-flex align-items-center justify-content-between" style={{ height: '80px' }}>
                <div className="d-flex align-items-center overflow-hidden">
                    <h4 className="fw-bold m-0" style={{ letterSpacing: '2px', color: colors.activeMenu }}>
                        {isSidebarOpen ? "HANDDN" : "H"}
                    </h4>
                </div>

                {isSidebarOpen && (
                    <div onClick={toggleDarkMode} className="d-flex justify-content-center align-items-center rounded-circle hover-card shadow-sm"
                        style={{
                            width: '35px',
                            height: '35px',
                            backgroundColor: colors.bgCard,
                            cursor: 'pointer',
                            border: `1px solid ${colors.borderColor}`,
                            transition: 'all 0.2s'
                        }}
                        title="Toggle Theme">
                        {isDarkMode
                            ? <Sun size={16} style={{ color: '#facc15' }} />
                            : <Moon size={16} style={{ color: '#6366f1' }} />}
                    </div>
                )}
            </div>

            {/* MENU ITEMS */}
            <div className="flex-grow-1 p-3 mt-2 overflow-hidden">
                <nav className="nav flex-column gap-2">
                    {menuItems.map((item) => (
                        <button
                            key={item.id}
                            onClick={() => dispatch({ type: "CHANGE_TAB", payload: item.id })}
                            className={`nav-link d-flex align-items-center border-0 py-3 px-3 rounded-pill menu-item ${activeTab === item.id ? 'shadow-sm' : ''}`}
                            style={{
                                backgroundColor: activeTab === item.id ? colors.activeMenu : 'transparent',
                                color: activeTab === item.id ? '#fff' : colors.textMuted,
                                whiteSpace: 'nowrap',
                                width: '100%',
                                transition: 'all 0.2s ease',
                                textAlign: 'left'
                            }}
                        >
                            <item.Icon size={20} style={{ marginRight: isSidebarOpen ? '15px' : '0', flexShrink: 0 }} />
                            {isSidebarOpen && (
                                <span style={{ fontSize: '15px', fontWeight: '600', opacity: 1 }}>
                                    {item.label}
                                </span>
                            )}
                        </button>
                    ))}
                </nav>
            </div>
        </div>
    );
};

export default Sidebar;